<template>
  <CloudModal v-bind="allPropsData" v-on="$listeners" :key="key">
    <template v-if="$slots.header" slot="header">
      <slot name="header"></slot>
    </template>
    <LutticaScrollBar
      :height="slotHeight + 'px'"
      :modal-visible="allPropsData.value"
      ref="LutticaScrollBar"
    >
      <div ref="bodySlot">
        <slot></slot>
      </div>
    </LutticaScrollBar>
    <template v-if="$slots.footer" slot="footer">
      <slot name="footer"></slot>
    </template>
  </CloudModal>
</template>

<script>
export default {
  data() {
    return {
      key: new Date().getTime(),
      slotHeight: 0, //内容高度
    };
  },
  updated() {
    if (this.$refs.bodySlot) {
      const height = this.height || this.$refs.bodySlot.clientHeight + 15 || this.modalHeight;
      if (height > this.maxHeight) this.slotHeight = this.maxHeight;
      else this.slotHeight = height;
    }
  },
  name: 'LutticaModal',
  computed: {
    allPropsData() {
      return Object.assign({
        ...this.$attrs,
        maskClosable: true,
        className: `${this.$attrs.className} luttica-modal-wrap`,
      });
    },
    modalHeight() {
      return this.$store.state.contentHeight - 110 - 50 - 80;
    },
    height() {
      return parseFloat(this.$attrs.height);
    },
    maxHeight() {
      const { height, maxHeight } = this.$attrs;
      if (!height && !maxHeight) {
        return this.modalHeight;
      }
      return parseFloat(maxHeight || height);
    },
  },
  mounted() {},
  methods: {
    scrollRefs() {
      return this.$refs.LutticaScrollBar;
    },
    updateContentHeight() {
      if (this.$refs.bodySlot) {
        this.$nextTick(() => {
          const height = this.$refs.bodySlot.clientHeight + 15;
          if (height > this.maxHeight) this.slotHeight = this.maxHeight;
          else this.slotHeight = height;
        });
      }
    },
  },
};
</script>

<style lang="less">
.luttica-modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal-body {
    padding: 16px 0 16px 16px;
  }

  .luttica-scroll-bar {
    .__view {
      padding-right: 16px;
      width: 100% !important;
    }
  }
}
</style>
